import React from 'react';
import App from './../app.jsx';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute.jsx';
import UserManagement from '../pages/admin/UserManagement';
import Statistics from '../pages/admin/Statistics';
import PolicyAllowLists from '../pages/admin/PolicyAllowLists.jsx';
import Orchestrations from '../pages/ai-tools/Orchestrations.jsx';
import AdminPolicies from '../pages/admin/AdminPolicies.jsx'
import AdminSettings from '../pages/admin/AdminSettings.jsx';

import SmallPentest from './../pages/small-pentest/small-pentest.js';
import CronTests from '../pages/cron-tests/CronTests.jsx';
import PagesError from './../pages/pages/error.js';
import PagesLogin from './../pages/pages/login.js';
import Dashboard from '../pages/dashboard/dashboard.js';
import Agents from '../pages/agents/agents.js';
import AiChat from '../pages/ai/chat.js';
import Documentation from '../pages/documentation/Documentation.jsx';
import AITools from '../pages/ai-tools/AITools.jsx';
import ActivityLogs from '../pages/admin/ActivityLogs.jsx';
import LoginAttempts from '../pages/admin/LoginAttempts.jsx';

const AppRoute = [
  {
    path: '*', 
    element: <App />,
    children: [
      {
        path: 'pages/login',
        element: <PagesLogin />
      },
    	{ path: '', element: <Navigate to='/small-pentest' /> },
      { 
        path: 'dashboard', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <Dashboard />
          </ProtectedRoute>
        )
      },
    	{ 
        path: 'small-pentest', 
        element: (
          <ProtectedRoute requiredRole="user">
            <SmallPentest />
          </ProtectedRoute>
        )
      },
      { 
        path: 'cron-tests', 
        element: (
          <ProtectedRoute requiredRole="superuser">
            <CronTests />
          </ProtectedRoute>
        )
      },
      { 
        path: 'agents', 
        element: (
          <ProtectedRoute requiredRole="superuser">
            <Agents />
          </ProtectedRoute>
        )
      },      
      { 
        path: 'ai-tools', 
        element: (
          <ProtectedRoute requiredRole={["admin", "superuser"]}>
            <AITools />
          </ProtectedRoute>
        )
      },
      { 
        path: 'aichat', 
        element: (
          <ProtectedRoute requiredRole="user">
            <AiChat />
          </ProtectedRoute>
        )
      },
      { 
        path: 'documentation', 
        element: (
          <ProtectedRoute requiredRole="user">
            <Documentation />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/users', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <UserManagement />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/statistics', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <Statistics />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/policies', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <AdminPolicies />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/settings', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <AdminSettings />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/policies/allow-lists', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <PolicyAllowLists />
          </ProtectedRoute>
        )
      },
      { 
        path: 'orchestrations', 
        element: (
          <ProtectedRoute requiredRole={["admin", "superuser"]}>
            <Orchestrations />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/activity-logs', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <ActivityLogs />
          </ProtectedRoute>
        )
      },
      { 
        path: 'admin/login-attempts', 
        element: (
          <ProtectedRoute requiredRole="admin">
            <LoginAttempts />
          </ProtectedRoute>
        )
      },
      // Removed route for test-notifications
    	{ path: '*', element: <PagesError /> }
		]
  }
];

export default AppRoute;